// extracted by mini-css-extract-plugin
module.exports = {"container":"Historic_container__2p6CO","content":"Historic_content__WM_G1"};